var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHltVCms04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0673828 0H0V0.0673828H0.0673828V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3451 5.46533V1.752C43.3451 1.15661 42.8623 0.673875 42.2669 0.673875H13.9375C13.3421 0.673875 12.8594 1.15661 12.8594 1.752V5.46533",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9493 40.5347H43.3451V44.248C43.3451 44.8434 42.8624 45.3262 42.2669 45.3262H13.3984",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3447 12.8216V40.5347",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 27.3655V5.46526H43.3451V9.67704",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0122 3.06946H28.1919",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6528 42.9305H28.5513",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32178 33.6482V30.3961C7.32178 29.3044 8.20961 28.4159 9.30211 28.4159C10.3937 28.4159 11.2824 29.3044 11.2824 30.3961V33.6482",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62646 33.6482V30.3961C4.62646 27.8184 6.7236 25.7206 9.30211 25.7206C11.8797 25.7206 13.9777 27.8184 13.9777 30.3961V33.6482",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67627 45.3262H3.55371C3.05759 45.3262 2.65527 44.9239 2.65527 44.4277V34.5468C2.65527 34.0506 3.05759 33.6484 3.55371 33.6484H15.0507C15.547 33.6484 15.9492 34.0507 15.9492 34.5468V44.4277C15.9492 44.9239 15.547 45.3262 15.0507 45.3262H8.8208",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.102 20.5016C26.7222 20.5016 25.6035 21.6201 25.6035 23C25.6035 24.3799 26.7222 25.4984 28.102 25.4984C29.4818 25.4984 30.6004 24.3799 30.6004 23C30.6004 21.6201 29.4818 20.5016 28.102 20.5016Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1018 17.3496C24.1618 17.3496 20.7014 19.4015 18.7298 22.4947C18.5334 22.8028 18.5334 23.1971 18.7298 23.5052C20.7014 26.5983 24.1618 28.6503 28.1018 28.6503C32.0418 28.6503 35.5021 26.5983 37.4737 23.5052C37.6701 23.1971 37.6701 22.8028 37.4737 22.4947C35.5021 19.4015 32.0418 17.3496 28.1018 17.3496Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2925 29.8093L34.9111 16.1906",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHltVCms04);
export default __webpack_public_path__ + "static/media/HLT-vCMS04.c0ed20e8f122ee72a47d7b64dfd5a5d2.svg";
export { ForwardRef as ReactComponent };